import { DateCalendar } from '@mui/x-date-pickers'
import { CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import { FULL_CALENDAR_VIEW_TYPES } from './utils'
import WeekPicker from './MuiWeekPicker'
import RosterFilterWidget from './RosterFilterWidget'
import RosterLegendWidget from './RosterLegendWidget'

const RosterSidebar = ({
  // Visibility props
  showDatePicker = true,
  showWeekPicker = true,
  showFilters = true,
  showLegend = true,
  showItemSelector = true,
  
  // Date restriction props
  minDate,
  maxDate,
  lockedDates,
  
  // Regular props
  hideOptionSelectionDropDown,
  loadingData,
  itemOptions,
  selectedItem,
  setSelectedItem,
  getOptionValue,
  getOptionLabel,
  currentView,
  currentDate,
  handleChangeDate,
  filters,
  setFilters,
  legendItems,
  getSidebarLegendLabel,
  legendTitle,
}) => {
  const isDateDisabled = (date) => {
    if (minDate && date < minDate) return true
    if (maxDate && date > maxDate) return true
    if (lockedDates && lockedDates.some(locked => 
      date.format('YYYY-MM-DD') === locked.format('YYYY-MM-DD')
    )) return true
    return false
  }

  return (
    <div className="d-flex flex-column gap-1 align-items-center px-2">
      {!hideOptionSelectionDropDown && showItemSelector && (
        <CustomSelect
          isLoading={loadingData}
          options={itemOptions}
          value={selectedItem}
          onChangeEvent={(e) => {
            setSelectedItem(e.target.value)
          }}
          selectType={selectTypes.object}
          id="room"
          getOptionValue={getOptionValue}
          getOptionLabel={getOptionLabel}
        />
      )}
      {showDatePicker && currentView === FULL_CALENDAR_VIEW_TYPES.dayView && (
        <DateCalendar 
          value={currentDate} 
          onChange={handleChangeDate}
          minDate={minDate}
          maxDate={maxDate}
          shouldDisableDate={isDateDisabled}
        />
      )}
      {showWeekPicker && currentView === FULL_CALENDAR_VIEW_TYPES.weekView && (
        <WeekPicker 
          value={currentDate} 
          onChange={handleChangeDate}
          minDate={minDate}
          maxDate={maxDate}
        />
      )}
      {showFilters && <RosterFilterWidget filters={filters} setFilters={setFilters} />}
      {showLegend && (
        <RosterLegendWidget
          legendItems={legendItems}
          getLegendItemLabel={getSidebarLegendLabel}
          title={legendTitle}
        />
      )}
    </div>
  )
}

export default RosterSidebar 